import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { StepperDialogComponent } from 'src/app/components/stepper-dialog/stepper-dialog.component';
import { Item } from 'src/app/models/item';
import { AdminService } from 'src/app/services/admin.service';
import { GeneralService } from 'src/app/services/general.service';
import { MenuService } from 'src/app/services/menu.service';
import { FormBuilder, FormGroup, FormGroupName, Validators } from '@angular/forms';
import swal from 'sweetalert2';
import { UserService } from 'src/app/services/user.service';
import { LookUpService } from 'src/app/services/lookup.service';
import { AgentService } from 'src/app/services/agent.service';
import { alphaNumericOnly } from 'src/app/functions/validation-functions';
@Component({
  selector: 'app-agent-list',
  templateUrl: './agent-list.component.html',
  styleUrls: ['./agent-list.component.css']
})
export class AgentListComponent {
  @ViewChild(StepperDialogComponent) stepperDialogComponent!: StepperDialogComponent;
  graphdata: any[] = [];
  visibleColumnData: Item[] = [];
  visibleColumnsId:any[] = [];
  graphHeader :any[]=[];
  canView:boolean = false;
  canEdit:boolean = false;
  canDelete:boolean = false;
  canCreate:boolean = false;
  viewUrl:string="";
  editUrl:string="";
  createUrl:string="";
  deleteUrl:string="";
  userType:string='2';
  distributorId:number = 0;
  resellerId:number = 0;
  distributorList:Item[]=[];
  resellerList:Item[]=[];
  showActivateBlockPopup:boolean = false;
  showActivatePopup:boolean = false;
  activateBlockAgentForm: FormGroup;
  activateBlockFormSubmitted:boolean = false;
  addBeneficiary() {
    this.stepperDialogComponent.show = true;
  }
	menuId:number = 0;
	menuUrl : string = "";
  uniqueUserId:any;
  productPermissionText:any;
  productPermissionIds:any;
  existingProductPermissionText:any;
  existingProductPermissionIds:any;
  productList:Item[] = [];
  showPermissionPopup:boolean = false;
  canEditPermission:boolean = false;
  canEditAuthKeyPermission: Boolean = false;
  showAuthKeyConfigurationPopup:boolean = false;
  authKeyForm: FormGroup;
  submittedConfigForm:boolean = false;
  isAuthkeyExists:boolean = false;
  showLoader:boolean = false;
  constructor(private adminService: AdminService, private router:Router,private menuService:MenuService,private generalService: GeneralService,private fb: FormBuilder,private userService:UserService, private lookupService:LookUpService, private agentService : AgentService) {
    let obj = this.router.getCurrentNavigation()?.extras?.state;
    if(obj)
    {      
      this.menuId = parseInt(obj['menuId'])??0;
      this.menuUrl = obj['menuUrl'];
      this.getPermissions(this.menuId);
    }

    this.userType = generalService.getUserType();
    if(this.userType == '2')
    {
      this.bindDistributorDDL();
    }
    else
    {
      this.bindResellerDDL();
    }
    //this.getAgentDetails();

    this.activateBlockAgentForm = this.fb.group({
      "agentId": [this.generalService.getUniqueuserid(), [Validators.required]],
      "status": ['', [Validators.required]],
      "comment": ['', [Validators.required]]
    });

    this.authKeyForm = this.fb.group({
      "mobile": [''],
      "userKey": ['', [Validators.required]],
      "userId": [''],
      "authKey": ['']
    });
  }

  async getAgentDetails() {
    this.showLoader = true;
    const res = await this.adminService.AgentDetails(this.resellerId);   
    this.showLoader = false; 
    if (res != null && res.result) {
      this.graphdata = res.result.data;
      let index=3;
      let sort:string='asc';
      console.log(this.graphdata.sort( (a, b) => {
        if(sort == 'desc')
        {
          if (a[index].toString().toLowerCase() > b[index].toString().toLowerCase()) {
            return -1;
          }
          if (b[index].toString().toLowerCase() > a[index].toString().toLowerCase()) {
              return 1;
          }          
        }
        else
        {
          if (a[index].toString().toLowerCase() < b[index].toString().toLowerCase()) {
            return -1;
          }
          if (b[index].toString().toLowerCase() < a[index].toString().toLowerCase()) {
              return 1;
          }  
        }
        return index;
      }));
      this.graphHeader = res.result.header;
      this.visibleColumnData =  res.result.header.map((m:any,index:number)=>{return {id:index.toString(),name:m.key,checked:true}}).filter((f:any)=>{return !f.name.startsWith('Hidden_') });
      this.visibleColumnsId = this.visibleColumnData.map((m:any)=>{return m.id.toString()});
    }
  }

  onActionClick(data:any)
  {
    if(data)
    {
      if(data.action=="View")
      {
        this.router.navigateByUrl(this.viewUrl,{ state: { id:data.id, userId:data.id2, menuId : this.menuId, menuUrl : this.menuUrl, canEdit : this.canEdit, editUrl : this.editUrl }});
      }
      else if(data.action=="Edit")
      {
        this.router.navigateByUrl(this.editUrl,{ state: { id:data.id, menuId : this.menuId, menuUrl : this.menuUrl, canEdit : this.canEdit, editUrl : this.editUrl }});
      } 
      else if(data.action == "Reject"){
        this.activateBlockAgentForm.get('status')?.setValue(data?.id1?.toString());
        this.activateBlockAgentForm.get('agentId')?.setValue(data?.id?.toString());
        this.showActivateBlockPopup = true;
      }
      else if(data.action=="PermissionsEdit")
      {
        this.showPermissionPopup = true;
        this.uniqueUserId = data.id2;
        this.getInsuranceProductsDDL(data.id2);      
      }  
      else if(data.action=="AuthKeyPermissionsEdit")
      {
        this.showAuthKeyConfigurationPopup = true;
        this.getAuthKeyConfiguration(data.id2);    
      }  
    }
  }
  
  onCreateBtnClick(data:any)
  {
    this.router.navigateByUrl(this.createUrl,{ state: { id:data.id, menuId : this.menuId, menuUrl : this.menuUrl, canEdit : this.canEdit, editUrl : this.editUrl }});
  }

  async getPermissions(menuId:number)
  {
    let obj = {uniqueUserId:this.generalService.getUniqueuserid(),menuId:menuId};
    let res = await this.menuService.GetMenuPermissionsByUserId(obj);
    if(res && res.isSuccess)
    {
      if(res.result.userMenus.length > 0)
      {
        res.result.userMenus.forEach((element:any) => {
          if(element.permissionName.toLowerCase() =="create")
          {
            this.canCreate = true;
            this.createUrl = element.menuCommand;
          }
          else if(element.permissionName.toLowerCase() =="edit")
          {
            this.canEdit = true;
            this.editUrl = element.menuCommand;
          }
          else if(element.permissionName.toLowerCase() =="view")
          {
            this.canView = true;
            this.viewUrl = element.menuCommand;
          }
          else if(element.permissionName.toLowerCase() =="delete")
          {
            this.canDelete = true;
            this.deleteUrl = element.menuCommand;
          }
          else if(element.permissionName.toLowerCase() =="permissionsedit")
          {
            this.canEditPermission = true;
          }
          else if(element.permissionName.toLowerCase() =="authkeypermissionsedit")
          {
            this.canEditAuthKeyPermission = true;
          }
          
        });
      }      
    }
  }

  async bindDistributorDDL()
  {
    const res = await this.adminService.DistributorDropDown().then((response)=> { 
      if (response != null && response.result) {
          this.distributorList = response.result.map((m:any)=>{return {id:m.id,name:m.name}});
          this.distributorList.unshift({id:"0",name:"All"});
          if(this.distributorList.length > 0 ){
            this.distributorId = parseInt(this.distributorList[0].id??"0");
          }
          this.bindResellerDDL();//this.getAgentDetails();
      }   
    });
  }

  async bindResellerDDL()
  {
    const res = await this.adminService.ResellerDropDownByDistributorId(this.distributorId);  
    if (res != null && res.result) {
        this.resellerList = res.result.map((m:any)=>{return {id:m.id,name:m.name}});
        if(this.distributorId == 0){
          this.resellerList.unshift({id:"0",name:"All"});
        }
        if(this.resellerList.length > 0){
          this.resellerId = parseInt(this.resellerList[0].id??"0");
        }
        this.getAgentDetails();
    }  
  }

  async filterAgentData(){
    this.getAgentDetails();
  }

  closePopup(){
    this.showActivateBlockPopup = false;
  }

  async proceedActiveBlockAgent(){
    this.activateBlockFormSubmitted = true;
    if(this.activateBlockAgentForm.valid){     
      const res = await this.adminService.activateBlockAgent(this.activateBlockAgentForm.value);  
      if (res != null && res.result) {
          
          swal.fire({
            position: 'center',
            icon: res.result.code == 1 ? 'success' : 'error',
            title: res.result?.message,
            showCancelButton: false,
            showConfirmButton: true,
            // cancelButtonText: 'Ok',
            // cancelButtonColor: res.result.code == 1 ? "#0DB561" : "#DF3A4D",
            // showConfirmButton: true,
            confirmButtonText: 'Ok',
            confirmButtonColor: res.result.code == 1 ? "#0DB561" : "#DF3A4D"
          }).then(() => {
            if(res.result.code == 1){
              window.location.href = window.location.href;
            }
          }); 
        }
    }
  }

  get activateBlockAgentFormControls(){
    return this.activateBlockAgentForm.controls;
  }

  async getInsuranceProductsDDL(uniqueUserId:any){
    const res = await this.lookupService.GetUserInsuranceProducts(uniqueUserId)
    if (res != null && res.result) {
      this.productList = res.result.map((m:any) => { return {id : m.id, name : m.name, checked : m.isChecked}});
      this.productPermissionIds = this.productList?.filter((f:any)=>{f.checked == true})?.map((m:any)=> {return m.id}).toString();
      this.productPermissionText = this.productList?.filter((f:any)=>{f.checked == true})?.map((m:any)=> {return m.name}).join(', ');
      //this.setSelectedProducts();
    }
  }
  
  onMultiSelectChange(selectItems: Item[]): void {
    if(selectItems && selectItems.length > 0){
      this.productPermissionIds = selectItems.map((item:Item) => {return item.id}).toString();
      this.productPermissionText = selectItems.map((item:Item) => {return item.name}).join(', ');
    }
    else
    {
      this.productPermissionIds = "";
      this.productPermissionText = "";
    }
  }
  
  setSelectedProducts(){
    if(this.productPermissionIds != null && this.productPermissionIds != undefined && this.productPermissionIds != "" && this.productList?.length > 0)
    {
      let prodList = this.productPermissionIds.split(",");
      this.productPermissionText = this.productList.filter((f:any)=> {return prodList.includes(f.id.toString())}).map((m:any)=>{return m.name}).join(', ');
      this.productList = this.productList.map((obj:Item) => {
        return {...obj, checked : prodList.includes(obj?.id?.toString())}
      });
    }
  }

  async SaveUpdateUserProductPermission(){
    let obj = {
      uniqueUserId:this.uniqueUserId,
      productPermission : this.productPermissionIds
    };
    const res = await this.userService.SaveUpdateUserProductPermission(obj)
    if (res != null && res.result) {
      this.showPermissionPopup = false;
      swal.fire({
        position: 'center',
        icon: res.result?.code == 1 ?'success' : 'error',
        title: res.result?.message,
        showConfirmButton: false,
        timer: 3000,
      });
    }    
    else
    {
      this.showPermissionPopup = false;
      swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Something went wrong',
        showConfirmButton: false,
        timer: 3000,
      });
    }
  }

  async getAuthKeyConfiguration(uniqueUserId:any){
    this.isAuthkeyExists = false;
    const res = await this.agentService.GetAuthKeyConfiguration(uniqueUserId)
    if (res != null && res.result) {
      this.enableDisbaleAuthKeyForm(true);
      this.authKeyForm.patchValue(res.result);
      this.enableDisbaleAuthKeyForm(false);
      if(res.result.authKey??'' != '')
      {
        this.isAuthkeyExists = true;
      }
    }
  }

  async GenerateAuthenticationKey(){
    this.enableDisbaleAuthKeyForm(true);
    let obj = this.authKeyForm.value;
    this.enableDisbaleAuthKeyForm(false);
    const res = await this.agentService.GenerateAuthenticationKey(obj);    
    if (res != null && res.result  && res.result?.code == 1) {
      this.enableDisbaleAuthKey(true);
      this.authKeyForm.get('authKey')?.setValue(res.result?.data?.toString())
      this.enableDisbaleAuthKey(false);
    }
  }
  
  async UpdateAuthKeyConfiguration(){
    this.enableDisbaleAuthKeyForm(true);
    let isFormValid = false;
    let obj = this.authKeyForm.value;
    if(this.authKeyForm.valid){
      isFormValid = true;
    }    
    this.enableDisbaleAuthKeyForm(false);
    if(isFormValid){
      const res = await this.agentService.UpdateAuthKeyConfiguration(obj);    
      if (res != null && res.result  && res.result?.code == 1) {
        this.enableDisbaleAuthKey(true);
        this.authKeyForm.get('authKey')?.setValue(res.result?.data?.toString())
        this.enableDisbaleAuthKey(false);
      }

      swal.fire({
        position: 'center',
        icon: res?.result?.code == 1 ? 'success' : 'error',
        title: res.result?.message,
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonText: 'Ok',
        confirmButtonColor: res?.result?.code == 1 ? "#0DB561" : "#DF3A4D"
      }).then(() => {
        if(res.result.code == 1){
          window.location.href = window.location.href;
        }
      });   
    }
    else
    {
      swal.fire({
        position: 'center',
        icon: 'error',
        title: "Auth key configuration form is not valid",
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonText: 'Ok',
        confirmButtonColor: "#DF3A4D"
      });
    }
  }
  
  async removeAuthKey(){
    swal.fire({
      position: 'center',
      icon: 'warning',
      title:'Remove Auth Key',
      text: '',
      html: 'Are you sure you want to remove this authentication key? This action may affect access.',
      
      confirmButtonText: "Yes, Continue",
      confirmButtonColor:"#0DB561",
      showCancelButton: false,    
      cancelButtonText:"Don't want",

      showDenyButton: true,     
      denyButtonText: "Don't want",
      denyButtonColor:"#6e7881",

    }).then((result) => {
      if (result.isConfirmed) 
      {             
        this.proceedToRemoveAuthKey();
      } 
      else if (result.isDenied) 
      {
        
      }
    });
  }

  async proceedToRemoveAuthKey(){
    this.enableDisbaleAuthKeyForm(true);
    let obj = this.authKeyForm.value;   
    this.enableDisbaleAuthKeyForm(false);
    const res = await this.agentService.RemoveAuthKey(obj);    
    swal.fire({
      position: 'center',
      icon: res?.result?.code == 1 ? 'success' : 'error',
      title: res.result?.message,
      showCancelButton: false,
      showConfirmButton: true,
      confirmButtonText: 'Ok',
      confirmButtonColor: res?.result?.code == 1 ? "#0DB561" : "#DF3A4D"
    }).then(() => {
      if(res.result.code == 1){
        window.location.href = window.location.href;
      }
    }); 
  }

  enableDisbaleAuthKeyForm(makeEnable:boolean){
    if(makeEnable){
      this.authKeyForm.get('mobile')?.enable();
      this.authKeyForm.get('userId')?.enable();
    }
    else
    {
      this.authKeyForm.get('mobile')?.disable();
      this.authKeyForm.get('userId')?.disable();
    }
    this.enableDisbaleAuthKey(makeEnable);
  }
  
  enableDisbaleAuthKey(makeEnable:boolean){
    if(makeEnable){
      this.authKeyForm.get('authKey')?.enable();
    }
    else
    {
      this.authKeyForm.get('authKey')?.disable();
    }
  }

  get authKeyFormControl() {
    return this.authKeyForm.controls;
  }

  alphaNumericOnly(event:any): boolean {
    return alphaNumericOnly(event);
  }

}
